import { Image, Platform, Text, useWindowDimensions, View } from "react-native";
import { DayCount } from "./utils";
import Centered from "../../../../shared/Centered";
import {
  BGCurrentDayFrameMobile,
  BGHorDividerAndTrMobile,
  BGHorDividerMobile,
  BonusGamesModalDays,
  VipBadgeFramePng,
} from "../../../../assets";
import { useTranslation } from "react-i18next";

export interface BGDayMobileProps {
  day: DayCount;
  bonus: number;
  vipBonus?: number;
  currentDay?: number;
  isSmall: boolean;
  isVip?: boolean;
}

function BGDayMobile({
  day,
  bonus,
  vipBonus,
  currentDay,
  isSmall,
  isVip,
}: BGDayMobileProps) {
  const normalizedCurrentDay =
    currentDay != null && currentDay > 5 ? 5 : currentDay;
  const { t } = useTranslation();

  const isCurrent =
    normalizedCurrentDay != null && day === normalizedCurrentDay;

  const isFutureOrCurrent =
    normalizedCurrentDay != null ? day <= normalizedCurrentDay : false;
  const isPreviousDay =
    normalizedCurrentDay != null && day < normalizedCurrentDay;
  const { width, height } = useWindowDimensions();
  const isNative = Platform.OS !== "web";

  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        position: "relative",
        height: 60,
        marginBottom: 0,
        minHeight: 86, // 🔑 стабилна височина за Android
      }}
    >
      <View>
        <Text
          style={{
            fontWeight: "bold",
            color: "#fff",
            paddingBottom: -3,
            fontSize: 12,
            marginTop: -2,
          }}
        >
          {t("T_SITE_MODAL_BONUS_DAY", { defaultValue: "day" })} {day}
        </Text>
      </View>
      {/* DAY IMAGE */}
      <Image
        source={BonusGamesModalDays[day]}
        resizeMode="contain"
        style={{
          width: isSmall ? 90 : 120,
          height: 60,
          opacity: isFutureOrCurrent ? 1 : 0.4,
          marginTop: -2,
        }}
      />

      {/* BONUS TEXT */}
      <View
        style={{
          position: "absolute",
          bottom: isSmall ? 20 : 24,
          left: 0,
          right: 0,
          alignItems: "center",
        }}
      >
        <Text
          style={{
            fontSize: isSmall ? 16 : 16,
            fontWeight: "bold",
            color: isFutureOrCurrent ? "#e9bf43" : "#d1d1d1",
          }}
        >
          {bonus}
        </Text>
      </View>
      {isVip && (
        <View
          style={{
            position: "absolute",
            bottom: isSmall ? 8 : 24,
            left: 0,
            right: 0,
            alignItems: "center",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Image
              source={VipBadgeFramePng}
              style={{
                width: 14,
                height: 14,
              }}
            />
            <Text
              style={{
                fontSize: isSmall ? 10 : 16,
                fontWeight: "bold",
                color: isFutureOrCurrent ? "#e9bf43" : "#d1d1d1",
              }}
            >
              + {vipBonus}
            </Text>
          </View>
        </View>
      )}

      {/* CURRENT DAY FRAME */}
      {isCurrent && (
        <Image
          source={BGCurrentDayFrameMobile}
          resizeMode="contain"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: isVip ? -5 : -10,
          }}
        />
      )}

      {/* TOP DIVIDER (current day only) */}
      {/* {isCurrent && (
        <Image
          source={BGHorDividerAndTrMobile}
          resizeMode="contain"
          style={{
            // position: "absolute",
            // top: isSmall ? -18 : -10,
            // left: 0,
            // right: 0,
            // aspectRatio: 5.86,
            // opacity: isPreviousDay ? 0 : 1,
            maxWidth: isSmall ? 100 : undefined,
            height: 12,
            width: "100%",
          }}
        />
      )} */}

      <Image
        source={BGHorDividerAndTrMobile}
        resizeMode="contain"
        style={{
          position: "absolute",
          top: isVip ? -10 : -14,
          left: 0,
          right: 0,
          aspectRatio: 5.86,
          opacity: isPreviousDay ? 0 : 1,
          maxWidth: isSmall ? 150 : undefined,
          height: 12,
          width: "100%",
        }}
      />

      {/* BOTTOM DIVIDER */}
      <Image
        source={day === 5 ? BGHorDividerMobile : BGHorDividerAndTrMobile}
        resizeMode="contain"
        style={{
          position: "absolute",
          bottom: day === 5 ? 2 : isNative ? -14 : -15,
          left: 0,
          right: 0,
          // aspectRatio: day === 5 ? 150 : 5.86,
          opacity: isPreviousDay ? 0 : 1,
          maxWidth: isSmall ? 140 : undefined,
          height: 2,
          width: "100%",
        }}
      />
    </View>
  );
}

export default BGDayMobile;
